import { Component } from "react";
import { Button } from "react-bootstrap";
import { bindActionCreators } from 'redux';
import { actions, Errors } from "react-redux-form";
import { connect } from "react-redux";

import { CustomDropdown } from "../../../../../../common/custom-form/custom-dropdown.component";
import Translation from "../../../../../../common/translation/translation.component";
import { CONFIRMATION_VALUE, TRANSLATIONS as translation } from "../../../../../../../utils/constant.utils";
import { NotificationModal } from "../../../../../../common/modal/notification-modal.component";
import { InputFieldFloatingLabel as InputField } from "../../../../../../common/custom-form/select-filter.component";
import { ACTION_TYPES, MAX_LENGTH, MODAL_CUSTOM_MESSAGE, MODAL_TITLE, OUTPUT_COLUMN_TYPE, OUTPUT_COLUMN_SOURCE } from "../../../../../../../constants/external-constants";
import { ConfirmationNotificationModal } from "../../../../../../common/modal/confirmation-modal.component";
import { SelectFieldFloatingLabel as Select } from "../../../../../../common/custom-form/select-filter.component";
import { areDataEqual, toPascalCase } from "../../../../../../../utils/helpers.utils";
import TableWithButton from "../../../../../../common/details-table/table-with-button.component";
import { OutputConfigurationDetailsActions } from "../../../../../../../store/external/recharge-reducer/output-configuraton-details/output-configuration-details.reducer";
import OutputMultipleColumnModal from "../../../output-multiple-column/modal/output-multiple-column.modal.component";
import CustomizableOneColumn from "../../../../../../common/modal-popover/custom-one-column.component.js/customizable-one-column.component";
class OutputColumns extends Component {
    constructor(props) {
        super(props);
        this.state={
            dataTable:[[]],
            showWarning:true,
            showNotif: false,
            haveError: false,
            modalMessage: '',
            rowIndex: 0,
            rowColumnName: '',
            isUpdate: false,
            isMultipleSource: false,
            showFormModal: false,
            multipleSourceDataTable: [],
            actionButton: '',
            HeaderItem: [
                {
                    ColumnSource: {
                        propName: "ColumnSourceName",
                        name: "Column Source",
                        hidden: false,
                    },
                    ColumnName: {
                        propName: "ColumnName",
                        name: "Column Name",
                        hidden: false,
                    },
                    ColumnFormat: {
                        propName: "ColumnFormat",
                        name: "Column Format",
                        hidden: false
                    },
                    Values: {
                        propName: "Values",
                        name: "Values",
                        hidden: false
                    },
                    LastModified: {
                        propName: "LastModified",
                        name: "Last Modified",
                        hidden: false
                    }
                },
            ],
        }
    }
    componentDidMount() {
        const { dataItem } = this.props;

        if (Array.isArray(dataItem) && dataItem.length > 0) {
            // Ensure SortOrder is present
            const initializedDataItem = dataItem
                .map((item, index) => ({
                    ...item,
                    SortOrder: item.SortOrder ?? index + 1
                }))
                .sort((a, b) => a.SortOrder - b.SortOrder);

            this.setState({
                dataTable: [initializedDataItem]
            });
        }
    }
    componentDidUpdate(prevProps) {
        const { dataItem, fieldForm } = this.props;

        if (prevProps.fieldForm.ColumnSourceID !== fieldForm.ColumnSourceID) {
            if (parseInt(fieldForm.ColumnSourceID) === parseInt(OUTPUT_COLUMN_SOURCE.MultipleColumnSource.id) && this.state.actionButton?.trim().toLowerCase() !== ACTION_TYPES.Delete?.trim().toLowerCase()) {
                this.setState({
                    showModal: true,
                    isMultipleSource: true,
                    rowColumnName: '',
                    modalMessage: "Are you sure you want to create a column with multiple source?"
                });
                return true;
            } else {
                this.setState({
                    isMultipleSource: false
                });
            }
        }

        if (prevProps.dataItem !== dataItem && dataItem?.length > 0) {
            const initializedDataItem = dataItem
                .map((item, index) => ({
                    ...item,
                    SortOrder: item.SortOrder ?? index + 1
                }))
                .sort((a, b) => a.SortOrder - b.SortOrder);

            this.setState({
                dataTable: [initializedDataItem]
            });
        }
    }


    updateData = (key,newData) => {           
        this.setState((prevState) => {
            const updatedDataTable = [...prevState.dataTable];
    
            if (Array.isArray(updatedDataTable)) {

                const index = updatedDataTable.findIndex((item) => item.Key === key);
    
                if (index !== -1) {
                    updatedDataTable[index] = { ...updatedDataTable[0][index], 
                    ...newData[index]                       
                    };
                }
                updatedDataTable.sort((a,b) => new Date(a.ValidDateFrom) - new Date(b.ValidDateFrom)) 
                //this.props.fetchData(updatedDataTable);
                return { dataTable: updatedDataTable };
            } 
    
            return null;
        });
    };

    validateFormData = () => {
        const { outputColumnsDatatable } = this.props.outputConfigurationDetails;
        const { fieldForm } = this.props;
        const { rowIndex } = this.state
        if (outputColumnsDatatable?.dataTable[0]?.dataItem.length > 0) {
            const alreadyExist = outputColumnsDatatable?.dataTable?.[0]?.dataItem
                ?.filter((_, i) => i !== rowIndex)
                ?.some(
                    (item) =>
                        item.ColumnName?.trim().toLowerCase() === fieldForm.ColumnName?.trim().toLowerCase()
                );
            if (alreadyExist) {
                this.setState({
                    showNotif: true,
                    haveError: true,
                    modalMessage: "Same record already exists."
                });
                return true
            }
            else {
                this.onClickAdd();
            }
        }
        else {
            this.onClickAdd();
        }
    }

    onClickAdd = (buttonType) => {
        this.setState({
            showModal: true
        })
    }
    actionButtonValue = (actionButton) => {
        this.setState({
            actionButton: actionButton
        })
    }
    handleConfirmationModal = (buttonType) => {
        const { addUpdateOutputColumn, handleResetForm, fieldForm } = this.props;

        const isMultipleSource = parseInt(fieldForm.ColumnSourceID) === parseInt(OUTPUT_COLUMN_SOURCE.MultipleColumnSource.id);

        if (buttonType === CONFIRMATION_VALUE.Ok) {
            if (isMultipleSource) {
                this.setState({
                    showFormModal: true,
                    showModal: false,
                    actionButton: '',
                });
                return true;
            }

            addUpdateOutputColumn();
            handleResetForm(0);
            handleResetForm(OUTPUT_COLUMN_TYPE.MultipleOutputColumn.id);
            this.setState({
                showModal: false,
                enableEdit: false,
                activeDropdown: false,
                haveError: false,
                actionButton: '',
            });
        } else {
            handleResetForm(0);
            handleResetForm(OUTPUT_COLUMN_TYPE.MultipleOutputColumn.id);

            this.setState({
                showModal: false,
                showFormModal: isMultipleSource ? false : this.state.showFormModal,
                enableEdit: isMultipleSource ? false : this.state.enableEdit,
                actionButton: '',
            });

            if (isMultipleSource) {
                this.setState({
                    activeDropdown: false,
                    isUpdate: false,
                });
                return false;
            }
        }
    };

     toLocaleLanguage = (key, isCapitalize=true) => {
            const { locale } = this.props;
            if (locale === null || locale === '')
                return translation[translation['defaultLocaleLanguage']][key];
            
            return isCapitalize ? translation[locale][key]?.toUpperCase() : translation[locale][key];
    }

    handleCloseNotif = () => {
        this.setState({ showNotif: false, actionButton: '', });       
    }

    onRowClick = (index) => {
        const { viewOutputColumn, isReadAndWrite } = this.props;

        viewOutputColumn(index, this.state.dataTable).then((data) => {
            if (parseInt(data.ColumnSourceID) === parseInt(OUTPUT_COLUMN_SOURCE.MultipleColumnSource.id) && this.state.actionButton !== ACTION_TYPES.Delete?.trim().toLowerCase()) {
                this.setState({
                    showModal: true,
                    isMultipleSource: true,
                    isUpdate: true,
                    rowColumnName: data.ColumnName,
                });
            }
        });

        this.setState({
            activeDropdown: isReadAndWrite ? true : false,
            isUpdate: true,
            rowIndex: index
        });
    };

    deleteScopeDate = (index) => {
        const { deleteOutputColumnData } = this.props;

        deleteOutputColumnData(index, this.state.dataTable);
        this.resetAllOutputForms();
        this.setState({
            activeDropdown: false,
            isUpdate: false
        })
    }

    handleCancel = () => {
        this.resetAllOutputForms();
        this.setState({
            activeDropdown: false,
            isUpdate: false,
            haveError: false,
            actionButton: '',
        })
    }

    resetAllOutputForms = () => {
        const { handleResetForm } = this.props;
        handleResetForm(OUTPUT_COLUMN_TYPE.OutputColumn.id);
        handleResetForm(OUTPUT_COLUMN_TYPE.MultipleOutputColumn.id);
    }

    enableUpdateBtn = () => {
        const { fieldForm } = this.props
        const { outputColumnsDatatable } = this.props.outputConfigurationDetails;
        const { rowIndex } = this.state

        const { ID: _, ...formWithoutId } = fieldForm || {};
        const { ID: __, ...dataWithoutId } = outputColumnsDatatable?.dataTable[0]?.dataItem[rowIndex] || {};

        const enableUpdateBtn = !fieldForm.ColumnSourceID ||
            !fieldForm.ColumnName ||
            !fieldForm.ColumnFormatID ||
            (areDataEqual(formWithoutId, dataWithoutId));

        return enableUpdateBtn;
    }

    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: this.props.isReadAndWrite ? !prevState.activeDropdown : false }));
    }

    handleCloseFormModal = () => {
        this.resetAllOutputForms();
        this.setState({
            showFormModal: false,
            actionButton: '',
            activeDropdown: false,
            isUpdate: false,
        })
    }

    handleSaveReorderedColumns = (selectedCols) => {
        const { updateOutputColumnsDatatable } = this.props;

        this.setState(prevState => {
            const originalList = prevState.dataTable[0] || [];
            const updatedList = [];
            const usedIndexes = new Set();

            selectedCols.forEach((col, index) => {
                const filterColumnName = col.FilterName?.trim().toLowerCase(); // match by name

                const matchIndex = originalList.findIndex((item, idx) =>
                    item.ColumnName?.trim().toLowerCase() === filterColumnName &&
                    !usedIndexes.has(idx)
                );

                if (matchIndex !== -1) {
                    const matchedItem = { ...originalList[matchIndex], SortOrder: index + 1 };
                    updatedList.push(matchedItem);
                    usedIndexes.add(matchIndex);
                }
            });

            const remainingItems = originalList
                .filter((_, idx) => !usedIndexes.has(idx))
                .map((item, i) => ({
                    ...item,
                    SortOrder: updatedList.length + i + 1
                }));

            const finalList = [...updatedList, ...remainingItems];

            updateOutputColumnsDatatable(finalList);

            return {
                dataTable: [finalList],
                preventDataReset: false
            };
        });
    };
    render() {
        const { isUpdate, isMultipleSource, showFormModal } = this.state;
        const { title, columnData, columFormatData, columFormat1Data, columFormat2Data, columFormat3Data, columnMulitpleData, fieldForm, fieldProp, dataItem, headerItem,
                optionLabelKey, fieldFormMultiple, fieldPropMultiple, isReadAndWrite} = this.props;

        const disableColumnFormat = parseInt(fieldForm.ColumnSourceID) === parseInt(OUTPUT_COLUMN_SOURCE.MultipleColumnSource.id) || parseInt(fieldForm.ColumnSourceID) === parseInt(OUTPUT_COLUMN_SOURCE.None.id) || !fieldForm.ColumnSourceID
        const isGreaterThanOrEqual30 = dataItem.length >= 30;
        const disableAddBtn = !fieldForm.ColumnSourceID || !fieldForm.ColumnFormatID || !fieldForm.ColumnName || isGreaterThanOrEqual30;
        
        const sortedDataItem = this.state.dataTable[0] || [];

        const dataList = [{
            HeaderItem: headerItem,
            dataItem: sortedDataItem
        }];

        const formattedData = sortedDataItem.map((item, index) => {
            const pascalCaseName = toPascalCase(item.ColumnName || '');

            return {
                FilterId: item.ColumnName,
                FilterName: pascalCaseName,
                FilterValue: item.ColumnName,
                FieldType: "",
                SortOrder: index + 1
            };
        });
        return(
            <div>
                <Errors model="outputConfigurationDetailsForm.outputColumnScope" className="has-error" />
                <div className="control-container">
                <CustomDropdown
                    label={<Translation translationKey={title} />}
                    activeDropdown={this.state.activeDropdown}
                    toggleActiveState={this.toggleActiveState}
                >
                    <div className="add-sim-container add-cost-allocation-cont">
                        
                    <div className="details-form_layout--scope">
                        <div className="details-2-col-82w-container">
                            <NotificationModal
                                show={this.state.showNotif}
                                title={this.state.haveError ? 'Error' : 'Success'}
                                message={this.state.modalMessage}
                                handleModal={this.handleCloseNotif}
                                customClass={'comment-notification-modal notification-footer modal-text-bold'}
                            />

                            <Select
                                className="form-select required"
                                label={`${this.toLocaleLanguage('column_source')}`}
                                options={columnData}
                                value={fieldForm.ColumnSourceID}
                                placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                isError={false}
                                fieldProp={fieldProp+'ColumnSourceID'}
                                onChangeAction={(m, v) => this.props.filterColumnFormat(m, v)}
                                optionLabelKey={optionLabelKey}
                            />

                            <InputField
                                className="form-control"
                                requiredField
                                type="text"
                                label={this.toLocaleLanguage('column_name')}
                                value={fieldForm.ColumnName}
                                fieldProp={fieldProp+'ColumnName'}
                                maxLength={MAX_LENGTH.limit_255}
                                onChangeAction={this.onChangePlanComponent}
                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                                isError={this.state.haveError}
                            />

                            <Select
                                className={`form-select ${!disableColumnFormat ? 'required' : ''}`}
                                label={`${this.toLocaleLanguage('column_format')}`}
                                options={columFormatData}
                                optionLabelKey={optionLabelKey}
                                value={fieldForm.ColumnFormatID}
                                isError={false}
                                fieldProp={fieldProp +'ColumnFormatID'}
                                disabled={disableColumnFormat}
                                placeholder={disableColumnFormat ? '' : this.toLocaleLanguage('select_placeholder', false)}
                            />

                            <InputField
                                className="form-control"
                                type="text"
                                label={this.toLocaleLanguage('values')}
                                value={fieldForm.Values}
                                fieldProp={fieldProp+'Values'}
                                maxLength={MAX_LENGTH.limit_100}
                                onChangeAction={this.onChangePlanComponent}
                                placeholder={`${this.toLocaleLanguage('enter_text_placeholder', false)}`}
                            />

                    </div>

                    <div className="add-button-container custom-add-button">

                        <div className="btn-tooltiptext">
                            <Button variant="outline-secondary" className="btn-custom-violet-hover-outline" onClick={this.handleCancel}>Cancel</Button>
                        </div>

                        <ConfirmationNotificationModal
                            show={this.state.showModal}
                            message={isMultipleSource ? isUpdate ? MODAL_CUSTOM_MESSAGE.update_details : MODAL_CUSTOM_MESSAGE.multiple_soruce_column : isUpdate ? MODAL_CUSTOM_MESSAGE.update_details : MODAL_CUSTOM_MESSAGE.add_details}
                            title={isMultipleSource ? MODAL_TITLE.Colum_Source : isUpdate ? ACTION_TYPES.Update : ACTION_TYPES.Add}
                            handleModal={this.handleConfirmationModal}
                            customClass={'comment-notification-modal modal-text-bold'}
                        />

                            <div className="btn-tooltiptext">
                                    <Button
                                        disabled={ isUpdate ? this.enableUpdateBtn() : disableAddBtn }
                                        onClick={this.validateFormData}
                                        variant="primary"
                                        className="btn-add"
                                    >
                                        {`${isUpdate ? ACTION_TYPES.Update : ACTION_TYPES.Add}`}

                                    </Button>
                                <span className="tooltip-text"><Translation translationKey={isUpdate ? "update_output_column" : "add_output_column"} /></span>
                            </div>
                    </div>
                            
                        </div>                    
                    </div>
                    </CustomDropdown>
                </div>
                {dataList[0].dataItem.length > 0 &&
                    <div className={`output-scope-table table-no-scroll details-table-container add-equipment-container`}>
                        <CustomizableOneColumn 
                            firstList={formattedData}
                            resetFilter={false}
                            linkLabel={"Re-order Columns"}
                            modalTitle="Re-order Columns"
                            saveAction={this.handleSaveReorderedColumns}
                            isLinkDisabled={ isReadAndWrite ? !(dataList[0].dataItem.length > 1) : true}
                        />
                        <TableWithButton
                            classNameWrapper={`table-details-wrapper table-clickable table-max-width ${dataItem?.length > 5 ? 'table-has-scrollbar' : ''} me-0`}
                            datatable={dataList}
                            haveExternalDeleteBtn={isReadAndWrite ? true : false}
                            deleteAction={(index) => this.deleteScopeDate(index)}
                            rowClickAction={this.onRowClick}
                            handleOpenNotif={this.handleOpenNotif}
                            hideDeleteBtn={false}
                            updateNotifTitle={this.updateNotifTitle}
                            deleteTooltip={<Translation translationKey={"delete_record"} />}
                            actionButtonValue={this.actionButtonValue}
                            handleCloseNotif={this.handleCancel}
                        />
                    </div>
                }
                
                <OutputMultipleColumnModal
                    showModalForm={showFormModal}
                    handleCloseFormModal={this.handleCloseFormModal}
                    handleConfirmationModal={this.handleConfirmationModal}
                    primaryBtnTooltip={`${isUpdate ? "update_column" : "add_column"}`}
                    primaryBtnLabel={`${isUpdate ? "Update Column" : "Add Column"}`}
                    columnSourceOption={columnMulitpleData}
                    columnFormatOption={columFormatData}
                    columnFormat1Option={columFormat1Data}
                    columnFormat2Option={columFormat2Data}
                    columnFormat3Option={columFormat3Data}
                    optionLabelKey={optionLabelKey}
                    fieldFormMultiple={fieldFormMultiple}
                    fieldPropMultiple={fieldPropMultiple}
                    rowColumnName={this.state.rowColumnName}
                    isUpdate={isUpdate}
                    isGreaterThanOrEqual30={isGreaterThanOrEqual30}
                />
            </div>
        )
    }
}

export default connect(
    state => {
        const { translation
            , adminSetting
            , outputConfigurationDetails } = state;
        return {
            ...translation
            , adminSetting
            , outputConfigurationDetails
        }
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, OutputConfigurationDetailsActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        },
    })
)(OutputColumns);